<div nz-space nzAlign="end" class="flex space-align-block">
  <ng-container *ngFor="let button of buttonList">
      <a  (click)="hanlder(button)"
          [ngClass]="['flex items-center justify-center', button.className? button.className : '']" 
          [nzTooltipTitle]="button.text" 
          nzTooltipPlacement="top" 
          nz-tooltip
          >
        <i nz-icon [nzType]="button.icon" [nzTheme]="button.nzTheme"></i>
      </a>
  </ng-container>
</div>